import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { type SxProps, type Theme } from '@mui/material/styles';
import Link from 'next/link';
import UviloLogo from './UviloLogo';
import clsx from 'clsx';
import mergeSxProps from '@erikdakoda/ui/shared/mergeSxProps';

type Props = {
  className?: string | string[];
  logoClass?: string | string[];
  placement?: 'left' | 'center' | 'right';
  sx?: SxProps<Theme>;
};

const UviloBranding = ({ className, logoClass, placement = 'left', sx }: Props) => {
  return (
    <Link href="/" className={clsx(className)} style={{ textDecoration: 'none' }}>
      <Box
        sx={mergeSxProps(sx, {
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          color: 'text.primary',
          marginRight: placement === 'left' ? 12 : 0,
        })}
      >
        <Box sx={{ width: 100 }}>
          <UviloLogo className={logoClass} sx={{ color: 'white' }} />
        </Box>
        <Typography
          variant="caption"
          sx={{
            ml: 1,
            fontSize: '0.6rem',
            lineHeight: '0.40rem',
            alignSelf: 'flex-end',
            width: placement === 'center' ? 0 : undefined,
            display: placement === 'right' ? 'none' : undefined,
            opacity: 0.7,
          }}
        >
          {process.env.APP_VERSION}
        </Typography>
      </Box>
    </Link>
  );
};

export default UviloBranding;
